/** @file startAutorigReview: asks the auto-rig panel to open one analysis with arguments and run it at once. */
import { autorigRequestStore } from './autorigRequestStore';

/** E1.7's "Suggest IK" entry (W3-70): kept until a panel mounts; an unknown `fn` is dropped by the panel. */
export function startAutorigReview(fn: string, args?: Record<string, unknown>): void {
  autorigRequestStore.setState({ request: { fn, args: { ...args } } });
}
